export const TEXT_NODE_TYPE = "text";
export const COMMENT_NODE_SYMBOL = Symbol.for("v-cmt");
